import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { ProductSummaryPseComponent } from './product-summary-pse.component';
import { ProductSummaryPseRoutingModule } from './product-summary-pse-routing.module';
import { VoucherModule } from 'src/app/shared/components/voucher/voucher.module';
import { AlertModule } from 'src/app/shared/components/alert/alert.module';

@NgModule({
  declarations: [ProductSummaryPseComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ProductSummaryPseRoutingModule,
    MatInputModule,
    MatRadioModule,
    VoucherModule,
    MatDialogModule,
    PipesModule,
    AlertModule
  ]
})
export class ProductSummaryPseModule {}
